import React from "react";

const Edit = ({ color = "#000000", size = "20" }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.99998 10.6671H11.25M0.75 10.6671H1.72682C2.01217 10.6671 2.15485 10.6671 2.28912 10.6349C2.40816 10.6063 2.52196 10.5592 2.62635 10.4952C2.74408 10.4231 2.84497 10.3222 3.04675 10.1204L10.375 2.79212C10.8583 2.30888 10.8583 1.52537 10.375 1.04212C9.89177 0.558875 9.10826 0.558876 8.62501 1.04212L1.29674 8.37039C1.09496 8.57217 0.994069 8.67306 0.92192 8.79079C0.857953 8.89518 0.810815 9.00898 0.782235 9.12802C0.75 9.26229 0.75 9.40497 0.75 9.69032V10.6671Z"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Edit;
